export function register() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
    return;
  }

  const registerSW = () => {
    const swUrl = `${process.env.PUBLIC_URL || ""}/firebase-messaging-sw.js`;

    navigator.serviceWorker
      .register(swUrl, { scope: "/" })
      .then((registration) => {
        console.log("Firebase Messaging Service Worker registered with scope:", registration.scope);
      })
      .catch((error) => {
        console.warn("Service Worker registration error:", error);
      });
  };

  if (document.readyState === "complete") {
    registerSW();
  } else {
    window.addEventListener("load", registerSW);
  }
}

export function unregister() {
  if (!("serviceWorker" in navigator)) {
    return;
  }
  navigator.serviceWorker.ready
    .then((registration) => {
      registration.unregister();
    })
    .catch(() => {});
}
